import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5355f290"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "p-px-3 p-pt-3" }
const _hoisted_2 = { class: "p-inputgroup panel-input-serach" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-search" }, null, -1))
const _hoisted_4 = [
  _hoisted_3
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_ProductList = _resolveComponent("ProductList")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("span", {
          class: _normalizeClass(['p-inputgroup-addon icon-input-search']),
          style: _normalizeStyle({ backgroundColor: _ctx.backgroundColor })
        }, _hoisted_4, 4),
        _createVNode(_component_InputText, {
          class: "input-serach",
          placeholder: "ค้นหาสินค้าด้วยคีย์เวิร์ดหรือชื่อสินค้า",
          modelValue: _ctx.filter.search,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filter.search) = $event)),
          onKeyup: _ctx.handleSearch
        }, null, 8, ["modelValue", "onKeyup"])
      ])
    ]),
    _createElementVNode("div", null, [
      _createVNode(_component_ProductList, {
        products: _ctx.products,
        productCount: _ctx.productCount,
        onInfiniteHandler: _ctx.infiniteHandler
      }, null, 8, ["products", "productCount", "onInfiniteHandler"])
    ])
  ]))
}